module.exports = __webpack_public_path__ + "img/decore-right.77c53a83.png";